import { render } from "./AddCustomer.vue?vue&type=template&id=2f368519&scoped=true"
import script from "./AddCustomer.vue?vue&type=script&lang=js"
export * from "./AddCustomer.vue?vue&type=script&lang=js"

import "./AddCustomer.vue?vue&type=style&index=0&id=2f368519&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f368519"]])

export default __exports__